import React from 'react';

const Focus = ({value}) => {
    const values = React.useMemo(() => {
        const dim = [];
        let accumulator = '';
        for (let i = 0; i < value.length; i++) {
            const current = value[i];
            if (i + 4 <= value.length) {
                const em =  value.substring(i, i + 4);
                if (em === '<em>') {
                    if (accumulator !== '') {
                        dim.push(accumulator);
                        accumulator = '';
                    }
                }
            }
            accumulator += current;
            if (i - 4 >= 0) {
                const em =  value.substring(i - 4, i + 1);
                if (em === '</em>') {
                    if (accumulator !== '') {
                        dim.push(accumulator);
                        accumulator = '';
                    }
                }
            }
        }
        if (accumulator !== '') {
            dim.push(accumulator);
            accumulator = '';
        }
        return dim;
    }, [value]);
    return (
        <>
            {values.map((e, i) => <span key={i}>
                {e.startsWith('<em>') ? <span className='bold'>{e.substring(4, e.length - 5)}</span> : e}
            </span>)}
        </>
    );
};

export default React.memo(Focus);